module.exports = __webpack_public_path__ + "img/new-people-courier-delivery.78ebb511.png";